import { render, staticRenderFns } from "./index.vue?vue&type=template&id=06f90c92&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=06f90c92&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=06f90c92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f90c92",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TimeCountdown: require('/drone/src/components/TimeCountdown/index.vue').default,NumberVerify: require('/drone/src/components/NumberVerify/index.vue').default,QrPay: require('/drone/src/components/QrPay/index.vue').default})
